<template>
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0533 1.33325H4.46398C4.09339 1.33325 3.73797 1.47373 3.47592 1.72378C3.21387 1.97382 3.06665 2.31296 3.06665 2.66659V13.3333C3.06665 13.6869 3.21387 14.026 3.47592 14.2761C3.73797 14.5261 4.09339 14.6666 4.46398 14.6666H12.848C13.2186 14.6666 13.574 14.5261 13.836 14.2761C14.0981 14.026 14.2453 13.6869 14.2453 13.3333V5.33325L10.0533 1.33325Z"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.4507 11.3333H5.86133"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.4507 8.66675H5.86133"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.25866 6H6.55999H5.86133"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.0533 1.33325V5.33325H14.2453"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
